import { AsyncRouteProps } from 'src/components/AsyncRoute/AsyncRoute';
import {
  DinerConnectionsPaths,
  SubscriptionPurchasePaths,
} from 'src/environment';

export const SubscriptionsRoutes: { [key: string]: AsyncRouteProps } = {
  /* Native routes */
  [SubscriptionPurchasePaths.CANCEL]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Survey/SubscriptionsSurvey'),
    export: 'SubscriptionsSurvey',
  },
  [SubscriptionPurchasePaths.CANCEL_PLUS]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Survey/SubscriptionsSurvey'),
    export: 'SubscriptionsSurvey',
  },
  [SubscriptionPurchasePaths.CANCELLATION_PERK]: {
    module: () =>
      import('src/modules/Subscriptions/pages/CancellationPerk/SubscriptionCancellationPerk'),
    export: 'SubscriptionCancellationPerk',
  },
  [SubscriptionPurchasePaths.CANCELLATION_QUESTION]: {
    module: () =>
      import('src/modules/Subscriptions/pages/CancellationQuestion/SubscriptionCancellationQuestion'),
    export: 'SubscriptionCancellationQuestion',
  },
  [SubscriptionPurchasePaths.CANCELLATION_SURVEY]: {
    module: () =>
      import('src/modules/Subscriptions/pages/CancellationSurvey/SubscriptionCancellationSurvey'),
    export: 'SubscriptionCancellationSurvey',
  },
  [SubscriptionPurchasePaths.INFO_NATIVE]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Info/SubscriptionInfo'),
    export: 'WrappedSubscriptionInfo',
  },
  '/modules/subscriptions/edit': {
    module: () =>
      import('src/modules/Subscriptions/pages/Edit/SubscriptionEdit'),
    export: 'SubscriptionEdit',
  },

  [SubscriptionPurchasePaths.MANAGEMENT_ACTIONS]: {
    module: () =>
      import('src/modules/Subscriptions/pages/ManagementActions/SubscriptionManagementActions'),
    export: 'SubscriptionManagementActions',
  },
  [SubscriptionPurchasePaths.MANAGEMENT]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Management/SubscriptionManagement'),
    export: 'SubscriptionManagement',
  },
  [SubscriptionPurchasePaths.MANAGEMENT_PLUS]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Management/SubscriptionManagement'),
    export: 'SubscriptionManagement',
  },
  /* Defined /plus web routes */
  [SubscriptionPurchasePaths.CANCEL_CONFIRMATION]: {
    module: () =>
      import('src/modules/Subscriptions/pages/CancelConfirmation/SubscriptionCancelConfirmation'),
    export: 'SubscriptionCancelConfirmation',
  },
  '/plus/error': {
    module: () =>
      import('src/modules/Subscriptions/pages/Management/SubscriptionManagement'),
    export: 'SubscriptionManagement',
  },
  [SubscriptionPurchasePaths.INELGIBLE]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Ineligible/SubscriptionIneligible'),
    export: 'SubscriptionIneligible',
  },
  [SubscriptionPurchasePaths.CONFIRMATION]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Confirmation/SubscriptionConfirmation'),
    export: 'SubscriptionConfirmation',
  },
  [SubscriptionPurchasePaths.EDIT]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Edit/SubscriptionEdit'),
    export: 'SubscriptionEdit',
  },
  [SubscriptionPurchasePaths.INFO_SLUG]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Info/SubscriptionInfo'),
    export: 'WrappedSubscriptionInfo',
  },
  [SubscriptionPurchasePaths.INFO]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Info/SubscriptionInfo'),
    export: 'WrappedSubscriptionInfo',
  },
  /* Defined /partner web routes */
  [SubscriptionPurchasePaths.PARTNER_ERROR]: {
    module: () =>
      import('src/modules/Subscriptions/pages/PartnerError/SubscriptionPartnerError'),
    export: 'SubscriptionPartnerError',
  },
  /* Slug based /partner/:slug/ web routes */
  [DinerConnectionsPaths.ENTRY]: {
    module: () =>
      import('src/modules/DinerConnections/pages/DinerConnectionsEntry/DinerConnectionsEntry'),
    export: 'DinerConnectionsEntry',
  },
  [DinerConnectionsPaths.CONNECT]: {
    module: () =>
      import('src/modules/DinerConnections/pages/DinerConnectionsConnect/DinerConnectionsConnect'),
    export: 'DinerConnectionsConnect',
  },
  [SubscriptionPurchasePaths.MIGRATION_PARTNER_SUCCESS]: {
    module: () =>
      import('src/modules/Subscriptions/pages/MigrationPartnerSuccess/SubscriptionMigrationPartnerSuccess'),
    export: 'SubscriptionMigrationPartnerSuccess',
  },
  [SubscriptionPurchasePaths.MIGRATION_PARTNER]: {
    module: () =>
      import('src/modules/Subscriptions/pages/MigrationPartner/SubscriptionMigrationPartner'),
    export: 'SubscriptionMigrationPartner',
  },
  [SubscriptionPurchasePaths.PARTNER_GIVEAWAY_ELIGIBILITY]: {
    module: () =>
      import('src/modules/Subscriptions/pages/GiveawayEligibility/GiveawayEligibility'),
    export: 'SubscriptionGiveawayEligibility',
  },
  [SubscriptionPurchasePaths.PARTNER_SUBPAGE]: {
    module: () =>
      import('src/modules/Subscriptions/pages/PartnerSubpage/PartnerSubpage'),
    export: 'PartnerSubpage',
  },
  [SubscriptionPurchasePaths.PARTNER_PAGE]: {
    module: () =>
      import('src/modules/Subscriptions/pages/Info/SubscriptionInfo'),
    export: 'WrappedSubscriptionInfo',
  },
};
